import React from 'react';
import { Drawer } from 'antd';
import SidebarContent from '../Sidebar/SidebarContent';
import styles from './MobileDrawer.module.scss';
import logo from '../../logo.svg';

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  selectedKeys: string[];
  onMenuClick: ({ key }: { key: string }) => void;
}

const MobileDrawer: React.FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  selectedKeys,
  onMenuClick
}) => {
  return (
    <Drawer
      title={
        <div className={styles.logo}>
          <img src={logo} alt="logo" />
        </div>
      }
      placement="left"
      onClose={onClose}
      open={isOpen}
      width={270}
      className={styles.mobileDrawer}
      styles={{
        body: { padding: 0 },
        header: { 
          padding: '16px 24px',
          borderBottom: '0.5px solid var(--app-divider-color)'
        }
      }}
    >
      <SidebarContent 
        selectedKeys={selectedKeys}
        onMenuClick={onMenuClick}
      />
    </Drawer>
  );
};

export default MobileDrawer; 